<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15401_63870)">
      <path
        d="M11.875 3.75H4.375C4.03 3.75 3.75 4.03 3.75 4.375C3.75 4.72 4.03 5 4.375 5H11.875C12.22 5 12.5 4.72 12.5 4.375C12.5 4.03 12.22 3.75 11.875 3.75Z"
        fill="#153D49"
      />
      <path
        d="M9.375 6.25H4.375C4.03 6.25 3.75 6.53 3.75 6.875C3.75 7.22 4.03 7.5 4.375 7.5H9.375C9.72 7.5 10 7.22 10 6.875C10 6.53 9.72 6.25 9.375 6.25Z"
        fill="#153D49"
      />
      <path
        d="M13.75 0H2.5C1.12125 0 0 1.12125 0 2.5V15C0 15.2425 0.14 15.4638 0.36 15.5663C0.44375 15.605 0.535 15.625 0.625 15.625C0.76875 15.625 0.91125 15.575 1.025 15.48L4.60125 12.5H13.75C15.1288 12.5 16.25 11.3788 16.25 10V2.5C16.25 1.12125 15.1288 0 13.75 0ZM15 10C15 10.6887 14.44 11.25 13.75 11.25H4.375C4.22875 11.25 4.0875 11.3013 3.975 11.395L1.25 13.6662V2.5C1.25 1.81125 1.81 1.25 2.5 1.25H13.75C14.44 1.25 15 1.81125 15 2.5V10Z"
        fill="#153D49"
      />
      <path
        d="M17.5 5C17.155 5 16.875 5.28 16.875 5.625C16.875 5.97 17.155 6.25 17.5 6.25C18.19 6.25 18.75 6.81125 18.75 7.5V18.0737L16.64 16.3863C16.53 16.2988 16.3912 16.25 16.25 16.25H7.5C6.81 16.25 6.25 15.6887 6.25 15V14.375C6.25 14.03 5.97 13.75 5.625 13.75C5.28 13.75 5 14.03 5 14.375V15C5 16.3788 6.12125 17.5 7.5 17.5H16.03L18.9838 19.8637C19.0975 19.9537 19.2362 20 19.375 20C19.4662 20 19.5588 19.98 19.6463 19.9388C19.8625 19.8338 20 19.615 20 19.375V7.5C20 6.12125 18.8788 5 17.5 5Z"
        fill="#153D49"
      />
    </g>
    <defs>
      <clipPath id="clip0_15401_63870">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
